<ui-control-field
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  <p-inputNumber
    mode="decimal"
    [inputId]="id()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [suffix]="suffix()"
    [useGrouping]="false"
    [ngModel]="value()"
    (onInput)="updateValue($any($event).value)"
    (onBlur)="markAsTouched()" />
</ui-control-field>
